/**
 * @ngdoc Service
 */
(function() {
    'use strict';

    angular.module('vrm.components')
        .constant('VrmDefaultLang', 'en')
        .service('VrmLangService', VrmLangService);

    /* @ngInject */
    function VrmLangService(VrmDefaultLang,UserService, ApiService, locale, $q, localStorageService, vrmUserAccessLevel) {

        return {
            getLang: getLang,
            setLang: setLang,
            setLangLocal: setLangLocal,
        };

        function getLang() {
            const lang = localStorageService.get('language') || VrmDefaultLang;
            // If site is shared, fallback to local storage for language resolving
            if (ApiService.isShare())
            {
                var promise = $q.defer();
                promise.resolve(lang);
                return promise.promise;
            }

            // Otherwise take language of user
            return UserService.loading.then(function(user) {
                // If signed in as demo, don't force the app to English. Use the local storage language if one exists.
                if (!ApiService.isLoggedIn() || !user || user.accessLevel === vrmUserAccessLevel.DEMO) {
                    return lang;
                }
                return user.language ? user.language : 'en';
            });
        }

        /**
         * Change app language without saving it on a logged on users account
         * @param language
         */
        function setLangLocal(language) {
            locale.setLocale(language);
            localStorageService.set('language', language);
        }

        /**
         * Set languange
         * @param language
         * @returns {*}
         */
        async function setLang(language) {
            // Update settings locally for fast switch
            setLangLocal(language);

            // Check if sync is neccessary
            if (ApiService.isShare()) return;
            const user = await  UserService.getUser();
            if (user.accessLevel === vrmUserAccessLevel.DEMO) return;

            // Sync settings change
            await ApiService.users('settings', {
                language: language
            });
            UserService.reload();
        }
    }
})();
